import BaseCommand from "@/models/api/commands/BaseCommand";

export class ToggleFileSendWithInvoiceCommand extends BaseCommand {
  CommandName = "ToggleFileSendWithInvoice";
  Command: {
    FileTmpId: number;
  };
  constructor(sessionId: string, operationId: string, fileTmpId: number) {
    super(sessionId, operationId);
    this.Command = { FileTmpId: fileTmpId };
  }
}
